"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import mixpanel from "@/lib/mixpanel.client";

const isProduction = process.env.NEXT_PUBLIC_APP_ENV === "production";

export default function PageViewTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (!isProduction) return;

    window.fbq?.("track", "PageView");
    window.ttq?.page();
    mixpanel.track("PageView", {
      path: pathname,
    });
  }, [pathname]);

  return null;
}

